"use client";

let currentPageKey: string | null = null;
let currentRoute: string | null = null;
let currentSampleRate: number | undefined = undefined;

export function setTelemetryContext(input: {
  pageKey: string;
  route: string;
  sampleRate?: number;
}) {
  currentPageKey = input.pageKey;
  currentRoute = input.route;
  currentSampleRate = input.sampleRate;
}

export function getTelemetryContext() {
  return {
    pageKey: currentPageKey,
    route: currentRoute,
    sampleRate: currentSampleRate,
  };
}
